import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useModeOfTransportationService } from "contexts/ServiceContext";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";

import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

const useListOfTransportationModes = (): UseQueryResult<
  ModeOfTransportation[]
> => {
  const cardCode = useSelectedCustomerCode()[0];
  const modeOfTransportationService = useModeOfTransportationService();

  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    cardCode,
  });

  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    cardCode,
  });

  return useQuery({
    queryKey: ["modeOfTransportation", { cardCode }],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "ModeOfTransportation",
      });
      return cardCode
        ? modeOfTransportationService
            .listModesOfTransportation()
            .then((data) => data.value ?? [])
            .catch((err) => {
              trackQueryError(
                {
                  statusCode: err.statusCode as number,
                  message: err.message,
                },
                eventId
              );
              throw err;
            })
        : Promise.reject();
    },
    cacheTime: Infinity,
    staleTime: Infinity,
  });
};

export default useListOfTransportationModes;
